import React, {useMemo} from 'react'
import {useSelector} from 'react-redux'
import {
  DatelessCTA,
  DatelessCTAVariant
} from 'components/Accommodation/Offers/DatelessCTA/DatelessCTA'
import {getUserCountryCode} from 'modules/meta/selectors'

import {Box} from '@vio/atlas/helpers/Box'
import {sortTopRoomImagesByCaption} from '@vio/core/src/room/business/utils/sortRoomImages'

import {FrozenRoomOffer} from '../../FrozenRoomOffer/FrozenRoomOffer'
import {RoomOffersList} from '../../RoomOffersList'
import {RoomCardInfo} from '../RoomCardInfo'
import {RoomGalleryTiles} from '../RoomGalleryTiles'
import {RoomCardLayoutProps} from '../types'

export const RoomCardDesktop = ({
  room,
  onOpenRoomDetailsOverlay,
  roomsSplit,
  isDetailsLinkVisible,
  isFrozen,
  isDateless
}: RoomCardLayoutProps) => {
  const userCountry = useSelector(getUserCountryCode)

  const sortedImages = useMemo(
    () => sortTopRoomImagesByCaption(room.images),
    [room.images]
  )

  const renderRoomOffer = () => {
    if (isDateless)
      return (
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="flex-end"
          alignItems="flex-end"
        >
          <Box height="100%" minWidth="256px">
            <DatelessCTA variant={DatelessCTAVariant.RoomListing} />
          </Box>
        </Box>
      )

    return isFrozen ? (
      <FrozenRoomOffer room={room} />
    ) : (
      <RoomOffersList room={room} />
    )
  }

  return (
    <Box display="flex" flexDirection="row" gap="s600" padding="s600">
      <RoomGalleryTiles
        images={sortedImages}
        onClick={onOpenRoomDetailsOverlay}
        isDateless={isDateless}
      />
      <Box
        flexDirection="column"
        display="flex"
        justifyContent={isDateless ? 'space-between' : undefined}
        gap="s600"
        width="100%"
      >
        <RoomCardInfo
          room={room}
          userCountry={userCountry}
          roomsSplit={roomsSplit}
          onOpenRoomDetailsOverlay={onOpenRoomDetailsOverlay}
          isDetailsLinkVisible={isDetailsLinkVisible}
        />
        {renderRoomOffer()}
      </Box>
    </Box>
  )
}
